import { render, staticRenderFns } from "./UserGroupList.vue?vue&type=template&id=739eb7c7&scoped=true"
import script from "./UserGroupList.vue?vue&type=script&lang=js"
export * from "./UserGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739eb7c7",
  null
  
)

export default component.exports